import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import {
  CLASSE_DO_ALINHAMENTO,
  colunasDaLista,
  type AbaDaLista,
  type ColunaDaLista,
} from './colunas-da-lista';

const BLOCO_DA_COLUNA: Record<ColunaDaLista['alinhamento'], string> = {
  esquerda: 'h-4 w-24',
  direita: 'h-4 w-20 ml-auto',
  centro: 'h-8 w-8 mx-auto rounded',
};

/** O esqueleto tem as colunas da lista da aba (colunasDaLista), para a tabela não pular ao carregar. */
export function DocumentosTableSkeleton({ tipo = 'entradas' }: { tipo?: AbaDaLista }) {
  const colunas = colunasDaLista(tipo);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          {colunas.map(coluna => (
            <TableHead key={coluna.titulo} className={CLASSE_DO_ALINHAMENTO[coluna.alinhamento]}>
              {coluna.titulo}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {Array.from({ length: 5 }).map((_, index) => (
          <TableRow key={index}>
            {colunas.map(coluna => (
              <TableCell key={coluna.titulo}>
                <Skeleton className={BLOCO_DA_COLUNA[coluna.alinhamento]} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
